import { Component, inject } from '@angular/core';
import { MaskitoOptions } from '@maskito/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { MemberAuthViewModel } from '../../../../viewModels/member-auth-view-model';
import { VerifyMemberRequest } from '../../../../../../models/users/requests/verify-member-request';
import { StringExtensions } from '../../../../../../utils/string.extensions';
import { AssetSize } from '../../../../../../models/enum/dto/asset-size.enum';
import { createMemberWelcomeFormGroup } from '../../../../forms/member-welcome-form-group';

@Component({
  selector: 'app-member-welcome',
  templateUrl: './member-welcome.component.html',
  styleUrls: ['./member-welcome.component.scss', '../../auth.component.scss']
})
export class MemberWelcomeComponent extends BaseComponent {
  private viewModel = inject(MemberAuthViewModel);

  public authFlowTitle$ = this.viewModel.authFlowTitle$;
  public authFlowSubtext$ = this.viewModel.authFlowSubtext$;

  public formGroup = createMemberWelcomeFormGroup();
  public formSubmitted = false;

  public readonly sinMaskOptions: MaskitoOptions = {
    mask: ['-', '-', '-', ' ', '-', '-', '-', ' ', /\d/, /\d/, /\d/]
  };

  public customErrorMessages = {
    sin: {
      sinLastThreeDigits: $localize`Enter the last 3 digits of your SIN`
    },
    birthdate: {
      invalidDateFormat: $localize`Invalid date`
    }
  };

  setupBindings(): void {}

  setupViews(): void {}

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    const { birthdate, sin } = this.formGroup.getRawValue();
    const req = new VerifyMemberRequest(sin, birthdate);
    // API requires birthday to be in format YYYY-MM-DD
    // Birthday form item outputs in format DD/MM/YYYY
    req.birthdate = StringExtensions.convertDateFormatForBackend(req.birthdate);
    req.sin = StringExtensions.removeDashesFromSin(req.sin);
    this.viewModel.verifyMember(req);
  }

  public openContactPage(): void {
    this.viewModel.openContactPage();
  }

  protected readonly AssetSize = AssetSize;
}
